<template>
    <div>
        <v-dialog v-model="dialog" width="600" persistent>
            <v-card class="rounded-lg">
                <!-- Header -->
                <v-card-title class="d-flex justify-space-between align-center px-4 py-3" style="background-color: #121212; color: white;">
                    <div>
                        <span class="font-weight-bold text-h6" style="font-family: Saira Condensed, sans-serif;">{{ main_title }}</span>
                        <div class="text-caption" style="font-family: Saira Condensed, sans-serif;">{{ sub_title }}</div>
                    </div>
                    <v-btn icon color="white" @click="closeDialog()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider></v-divider>

                <!-- Form -->
                <v-card-text class="px-5 py-4">
                    <v-form ref="form">
                        <v-row dense>
                            <!-- Title -->
                            <v-col cols="12">
                                <v-text-field
                                    v-model="name"
                                    :rules="[formRules.required]"
                                    :label="$t('Fields_Label.Raffle.Title')"
                                    variant="outlined"
                                    color="primary"
                                    density="comfortable"
                                    style="font-family: Saira Condensed, sans-serif;"
                                ></v-text-field>
                            </v-col>

                            <!-- Description -->
                            <v-col cols="12">
                                <v-textarea
                                    v-model="description"
                                    :rules="[formRules.required, formRules.noSpacesOnly]"
                                    :label="$t('Fields_Label.Raffle.Description')"
                                    variant="outlined"
                                    color="primary"
                                    density="comfortable"
                                    rows="3"
                                    style="font-family: Saira Condensed, sans-serif;"
                                ></v-textarea>
                            </v-col>

                            <!-- Entry Cost -->
                            <v-col cols="12">
                                <v-row dense>
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="entryCost"
                                            :rules="[formRules.required]"
                                            :label="$t('Fields_Label.Raffle.Entry_Cost')"
                                            type="number"
                                            variant="outlined"
                                            color="primary"
                                            density="comfortable"
                                            style="font-family: Saira Condensed, sans-serif;"
                                            prepend-inner-icon="mdi-cash-multiple"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="numberOfWinners"
                                            :rules="[formRules.required, formRules.maxLength, formRules.minValue]"
                                            :label="$t('Fields_Label.Raffle.Maximum_Number_Of_Winners')"
                                            type="number"
                                            variant="outlined"
                                            color="primary"
                                            density="comfortable"
                                            style="font-family: Saira Condensed, sans-serif;"
                                            prepend-inner-icon="mdi-trophy"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>

                            <!-- Expiration Date & Time -->
                            <v-col cols="12">
                                <v-row dense>
                                    <!-- Expiration Date -->
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="manualDateInput"
                                            :label="$t('Fields_Label.Raffle.Expiration_Date')"
                                            placeholder="YYYY-MM-DD"
                                            variant="outlined"
                                            density="comfortable"
                                            :rules="[formRules.dateFormat]"
                                            @update:model-value="handleDateInput"
                                            prepend-inner-icon="mdi-calendar"
                                            style="font-family: Saira Condensed, sans-serif;"
                                        ></v-text-field>
                                        <!-- <v-menu v-model="dateMenu" transition="scale-transition" offset-y>
                                            <template v-slot:activator="{ props }">
                                                <v-btn 
                                                    v-bind="props"
                                                    variant="outlined" 
                                                    color="primary"
                                                    class="mt-2"
                                                    size="small"
                                                    style="font-family: Saira Condensed, sans-serif;"
                                                >
                                                    Select from Calendar
                                                </v-btn>
                                            </template>
                                            <v-date-picker
                                                v-model="calendarDate"
                                                :min="minDate"
                                                @update:model-value="handleCalendarDateSelect"
                                            ></v-date-picker>
                                        </v-menu> -->
                                        <!-- <div class="text-caption text-grey mt-1" style="font-family: Saira Condensed, sans-serif;">
                                            Format: YYYY-MM-DD
                                        </div> -->
                                    </v-col>

                                    <!-- Expiration Time -->
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="time"
                                            :label="$t('Fields_Label.Raffle.Expiration_Time')"
                                            placeholder="HH:MM (24h)"
                                            variant="outlined"
                                            density="comfortable"
                                            :rules="[formRules.timeFormat]"
                                            @update:model-value="updateDateTime"
                                            prepend-inner-icon="mdi-clock-time-four-outline"
                                            style="font-family: Saira Condensed, sans-serif;"
                                        ></v-text-field>
                                        <!-- <div class="text-caption text-grey mt-1" style="font-family: Saira Condensed, sans-serif;">
                                            24-hour format (e.g., 14:30, 23:45)
                                        </div> -->
                                    </v-col>
                                </v-row>
                            </v-col>

                            <!-- Image Upload Section - Unified Design -->
                            <v-col cols="12">
                                <v-row dense>
                                    <v-col cols="12" v-if="imgChange">
                                        <v-file-input
                                            v-model="file"
                                            :rules="[formRules.required, formRules.fileSize]"
                                            accept="image/*"
                                            :label="$t('Fields_Label.Raffle.Upload_Image')"
                                            variant="outlined"
                                            color="primary"
                                            density="comfortable"
                                            show-size
                                            prepend-inner-icon="mdi-image"
                                            style="font-family: Saira Condensed, sans-serif;"
                                        ></v-file-input>
                                        <div class="text-caption text-grey mt-1" style="font-family: Saira Condensed, sans-serif;">
                                            Maximum file size: 2MB. Supported formats: JPG, PNG, GIF
                                        </div>
                                    </v-col>
                                    
                                    <v-col cols="12" v-else>
                                        <v-row dense>
                                            <v-col cols="12" md="6">
                                                <v-img
                                                    class="mx-auto"
                                                    rounded="lg"
                                                    :src="imageUrl"
                                                    max-height="200"
                                                    contain
                                                    lazy-src="https://picsum.photos/id/11/100/60"
                                                >
                                                    <template v-slot:placeholder>
                                                        <div class="d-flex align-center justify-center fill-height">
                                                            <v-progress-circular color="grey-lighten-4" indeterminate></v-progress-circular>
                                                        </div>
                                                    </template>
                                                </v-img>
                                            </v-col>
                                            <v-col cols="12" md="6" class="d-flex align-center">
                                                <v-btn 
                                                    @click="imgChange = true" 
                                                    variant="outlined" 
                                                    color="primary"
                                                    class="w-100"
                                                    style="font-family: Saira Condensed, sans-serif;"
                                                    prepend-icon="mdi-image-edit"
                                                >
                                                    Change Image
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>

                <v-divider></v-divider>

                <!-- Actions -->
                <v-card-actions class="px-5 py-3">
                    <v-spacer></v-spacer>
                    <v-btn 
                        variant="outlined" 
                        color="grey" 
                        @click="closeDialog()"
                        :disabled="loading"
                        style="font-family: Saira Condensed, sans-serif;"
                    >
                        Cancel
                    </v-btn>
                    <v-btn 
                        variant="elevated" 
                        color="primary"
                        @click="validateForm()" 
                        :loading="loading"
                        style="font-family: Saira Condensed, sans-serif;"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Snackbar -->
        <v-snackbar v-model="snackbar" :timeout="2500" color="green" location="top">
            <v-icon>mdi-alert-circle</v-icon>
            <span class="ml-2" style="font-family: Saira Condensed, sans-serif;">{{ snackText }}</span>
        </v-snackbar>
    </div>
</template>

<script>
    import axios from 'axios';
    import { defineComponent } from 'vue'
    
    export default defineComponent({
        emits: ["refresh"],
        data () {
            return {
                dialog: false,
                calendarDate: null,
                manualDateInput: '',
                time: null,
                dateMenu: false,
                minDate: new Date().toISOString().split("T")[0],

                main_title: null,
                sub_title: null,
                action: null,
                loading: false,
                
                snackbar: false,
                snackText: null,

                id: null,
                name: null,
                description: null,
                entryCost: null,
                deadline: null,
                numberOfWinners: null,
                file: null,

                imgChange: false,
                imageUrl: null,

                formRules: {
                    required: value => !!value || 'Required',
                    minValue: value => (value && value != 0) || 'Must be greater than 0',
                    maxLength: value => (value && value.toString().length <= 10) || 'Must be less than or equal to 10 characters',
                    noSpacesOnly: value => (value && value.trim().length > 0) || 'This cannot be just spaces',
                    fileSize: value => {
                        if (value[0]){
                            return value[0].size <= 2 * 1024 * 1024 || 'File size must be less than 2MB';
                        }
                    },
                    dateFormat: value => {
                        if (!value) return true; // Allow empty for optional fields
                        const regex = /^\d{4}-\d{2}-\d{2}$/;
                        if (!regex.test(value)) return 'Please use YYYY-MM-DD format';
                        
                        // Additional validation for actual date validity
                        const date = new Date(value);
                        return date instanceof Date && !isNaN(date) || 'Please enter a valid date';
                    },
                    timeFormat: value => {
                        if (!value) return true; // Allow empty for optional fields
                        const regex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
                        if (!regex.test(value)) return 'Please use HH:MM format (24h)';
                        
                        // Additional validation for time components
                        const [hours, minutes] = value.split(':');
                        return (hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59) || 'Please enter a valid time';
                    }
                },
            }
        },
        methods: {
            initRaffle(){
                this.dialog = true;
            },
            initAdd(){
                this.dialog = true
                this.main_title = 'Add Raffle'
                this.sub_title = 'Add New Raffle Entry'
                this.action = 'add'
                this.imgChange = true
                this.calendarDate = null
                this.manualDateInput = ''
                this.time = null
            },

            initUpdate(data) {
                this.dialog = true;
                this.main_title = "Edit Raffle";
                this.sub_title = "Edit Raffle Entry";
                this.action = "edit";

                this.id = data._id;
                this.name = data.name;
                this.description = data.description;
                this.entryCost = data.entryCost;
                this.numberOfWinners = data.numberOfWinners;
                this.imageUrl = data.imageUrl;

                this.imgChange = !this.imageUrl;

                if (data.deadline) {
                    const deadlineDateTime = new Date(data.deadline);
                    // Set both calendar date and manual input
                    const dateStr = deadlineDateTime.toISOString().split('T')[0];
                    this.calendarDate = dateStr;
                    this.manualDateInput = dateStr;
                    
                    const hours = String(deadlineDateTime.getUTCHours()).padStart(2, "0");
                    const minutes = String(deadlineDateTime.getUTCMinutes()).padStart(2, "0");
                    this.time = `${hours}:${minutes}`;
                    
                    this.updateDateTime();
                }
            },
            closeDialog() {
                this.dialog = false;
                this.$refs.form.reset();
                this.calendarDate = null;
                this.manualDateInput = '';
                this.time = null;
            },
            handleCalendarDateSelect(date) {
                 // Ensure the date is formatted as YYYY-MM-DD
                if (date instanceof Date) {
                const isoDate = date.toISOString().split("T")[0];
                this.calendarDate = isoDate;
                this.manualDateInput = isoDate;
                } else if (typeof date === "string") {
                // If v-date-picker gives string (depending on Vuetify version)
                this.calendarDate = date;
                this.manualDateInput = date;
                }
                this.dateMenu = false;
                this.updateDateTime();
            },
            handleDateInput(value) {
                if (value && this.isValidDate(value)) {
                    // keep consistent format
                    this.calendarDate = value;
                    this.manualDateInput = value;
                    this.updateDateTime();
                }
            },
            isValidDate(dateString) {
                const regex = /^\d{4}-\d{2}-\d{2}$/;
                if (!regex.test(dateString)) return false;
                
                const date = new Date(dateString);
                return date instanceof Date && !isNaN(date);
            },
            updateDateTime() {
                const dateStr = this.calendarDate || this.manualDateInput;
                
                if (dateStr && this.time) {
                    // Validate both date and time formats
                    if (!this.isValidDate(dateStr)) {
                        console.error("Invalid date format");
                        return;
                    }

                    const timeStr = this.time.length === 5 ? `${this.time}:00` : this.time;

                    // Parse the date and time
                    const [year, month, day] = dateStr.split("-");
                    const [hour, minute, second] = timeStr.split(":");

                    // Create UTC date
                    const utcDate = new Date(Date.UTC(
                        parseInt(year),
                        parseInt(month) - 1,
                        parseInt(day),
                        parseInt(hour),
                        parseInt(minute),
                        parseInt(second)
                    ));

                    // Validate the resulting date
                    if (isNaN(utcDate.getTime())) {
                        console.error("Invalid date/time combination");
                        return;
                    }

                    this.deadline = utcDate.toISOString();
                    console.log("Updated Deadline:", this.deadline);
                }
            },
            async validateForm(){
                // First update the deadline to ensure it's current
                this.updateDateTime();
                
                const { valid } = await this.$refs.form.validate()

                if(valid) {
                    // Additional validation for date and time
                    if (!this.deadline) {
                        this.snackText = "Please provide a valid expiration date and time";
                        this.snackbar = true;
                        return;
                    }

                    const token = localStorage.getItem('maherco-admin-accesstoken')
                    
                    let payload = {
                        name: this.name,
                        description: this.description,
                        entryCost: this.entryCost,
                        deadline: this.deadline,
                        numberOfWinners: this.numberOfWinners,
                        file: this.file ?? null,
                    }

                    this.loading = true
                    if (this.action == 'add'){
                        axios.post(process.env.VUE_APP_SERVER_URL + '/api/admin/raffles', payload, { 
                            headers: { 
                                'Authorization': `Bearer ${token}`,
                                'Content-Type': 'multipart/form-data',
                                'x-admin-key': process.env.VUE_APP_X_ADMIN_KEY,
                            }
                        }).then((res)=>{
                            if(res.status == 200 || res.status == 201){
                                this.snackText = res.data.message
                                this.snackbar = true
                                this.$refs.form.reset()
                                this.dialog = false
                                this.$emit('refresh')
                            }
                        }).catch((error) => {
                            console.log(error)
                            if (error.response) {
                                if (error.response.status === 401) {
                                    localStorage.removeItem("vuex");
                                    localStorage.removeItem("maherco-admin-accesstoken");
                                    window.location.reload();
                                } else if (error.response.status === 400 || error.response.status === 422) {
                                    this.snackText = error.response.data.message || error.message
                                    this.snackbar = true
                                } 
                                else {
                                    console.log(`Error: ${error.response.status}`);
                                }
                            } 
                            else if (error.request) {
                                console.log('No response received', error.request);
                            } else {
                                this.snackText = error
                                this.snackbar = true
                                console.log('Error', error.message);
                            }
                        }).finally(() => {
                            this.loading = false
                        });
                    }
                    else if(this.action == 'edit'){
                        axios.patch(process.env.VUE_APP_SERVER_URL + `/api/admin/raffles/${this.id}`, payload, { 
                            headers: { 
                                'Authorization': `Bearer ${token}`,
                                'Content-Type': 'multipart/form-data',
                                'x-admin-key': process.env.VUE_APP_X_ADMIN_KEY,
                            }
                        }).then((res)=>{
                            if(res.data){
                                this.$emit('refresh')
                                this.loading = false
                                this.snackText = res.data.message
                                this.snackbar = true
                                this.$refs.form.reset();
                                this.dialog = false
                            }
                        }).catch((error) => {
                            if (error.response) {
                                if (error.response.status === 401) {
                                        localStorage.removeItem("vuex");
                                        localStorage.removeItem("maherco-admin-accesstoken");
                                        window.location.reload();
                                } else {
                                    console.log(`Error: ${error.response.status}`);
                                }
                            } 
                            else if (error.request) {
                                console.log('No response received', error.request);
                            } else {
                                console.log('Error', error.message);
                            }
                        });
                    }
                }
            }
        }
    })
</script>

<style scoped>

</style>